import { vec, type Vec2 } from './vec2';

export interface Bounds {
  readonly min: Vec2;
  readonly max: Vec2;
}

/** Axis-aligned box around a non-empty set of points. */
export function boundsOfPoints(points: readonly Vec2[]): Bounds {
  const xs = points.map((point) => point.x);
  const ys = points.map((point) => point.y);
  return {
    min: vec(Math.min(...xs), Math.min(...ys)),
    max: vec(Math.max(...xs), Math.max(...ys)),
  };
}

export function unionBounds(a: Bounds, b: Bounds): Bounds {
  return {
    min: vec(Math.min(a.min.x, b.min.x), Math.min(a.min.y, b.min.y)),
    max: vec(Math.max(a.max.x, b.max.x), Math.max(a.max.y, b.max.y)),
  };
}

export function boundsIntersect(a: Bounds, b: Bounds, margin = 0): boolean {
  return (
    a.min.x - margin <= b.max.x &&
    a.max.x + margin >= b.min.x &&
    a.min.y - margin <= b.max.y &&
    a.max.y + margin >= b.min.y
  );
}

export function boundsContain(outer: Bounds, inner: Bounds): boolean {
  return (
    outer.min.x <= inner.min.x &&
    outer.min.y <= inner.min.y &&
    outer.max.x >= inner.max.x &&
    outer.max.y >= inner.max.y
  );
}
